import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import ConsentRequestInvestorApproval from '../../../interfaces/consent-request-investor-approval';
import Permission from '../../../interfaces/permission';
import ConsentApprovalStatus from '../../../interfaces/consent-approval-status';

import { MatButtonToggleChange } from '@angular/material/button-toggle';
import { InvestorApprovalTableItem } from '../consent-approvals.component';

@Component({
    selector: 'consent-investor-approvals-table',
    templateUrl: './investor-approvals-table.component.html',
    styleUrls: ['./investor-approvals-table.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class InvestorApprovalsTableComponent {
  public columns = [
    'investor',
    'owned_percent',
    'approval_status',
    'status_date',
    'comments',
  ];

  @Input() readOnly = true;
  @Input() permission: Permission | null;
  @Input() approvalStatuses: ConsentApprovalStatus[];
  @Input() investorApprovals: InvestorApprovalTableItem[];
  @Output() investorApprovalsChange = new EventEmitter<
    ConsentRequestInvestorApproval[]
  >();
}
